import React from 'react';

const ExceededMessage = function ExceededMessage(props) {
  const { isBookingsLimit } = props;
  const title = isBookingsLimit ? 'BookThatApp plan exceeded:' : 'BookThatApp free trial exceeded:';
  const selectedPlan = isBookingsLimit ? 'selected plan' : 'free trial';
  const upgradePlan = isBookingsLimit ? 'upgrade your' : 'upgrade to a paid';

  return (
    <>
      {title}
      <br />
      <br />
      you have exceeded the maximum number of bookings allowed under your&nbsp;
      {selectedPlan}
      . Please&nbsp;
        <span>
          <a href="/admin/charges">{upgradePlan}</a>
        </span>
      &nbsp;BookThatApp subscription plan to continue using the App.
    </>
  );
};

export default ExceededMessage;
